import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { ProductModelExtendedImages } from "@toolkit/Framework/Types/ApiModels";

const getProductVideoUrl = (product: ProductModel, imageId: string) => {
    if (!product.properties.extendedImages) {
        return undefined;
    }

    try {
        const extendedImages = JSON.parse(product.properties.extendedImages) as ProductModelExtendedImages[];
        const videoUrl = extendedImages.find(i => i.id === imageId)?.properties?.videoUrl;
        const match = videoUrl?.match(/src=["']([^"']+)["']/i);

        return match ? match[1] : videoUrl;
    } catch (error) {
        return undefined;
    }
};

export default getProductVideoUrl;
